const signals = require('../../signals/order');
const { raiseEvent } = require('../../signals/analytics');
const CustomOrder = require('../common/custom-order');
const Discounts = require('../common/discounts');
const Slider = require('./slider');
const css = require('./order.css');
const { cut } = require('../../helpers/utils');

const COST_BUTTON_SELECTOR = cut(css.costButton);
const DOWNLOAD_SAMPLE_BUTTON = cut(css.actionsButton);
const MANAGER_MAIL_TO_LINK = cut(css.managerLink);


class Order {
    constructor () {
        this.template = require('./template.hbs');
        this.intervalId = null;
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }));
    }

    bind () {
        this.$context.signal(signals.onLoad);

        return {
            click: {
                [COST_BUTTON_SELECTOR]: this.handleCostButton,
                [DOWNLOAD_SAMPLE_BUTTON]: this.downloadSampleEvent,
                [MANAGER_MAIL_TO_LINK]: this.mailToManager
            }
        };
    }

    handleCostButton (e) {
        e.preventDefault();

        this.$context.signal(raiseEvent, { category: 'button_price_to_choice_fetching', action: 'click' });
        this.$context.signal(signals.clickCostButton);
    }

    downloadSampleEvent () {
        this.$context.signal(raiseEvent, { category: 'button_download_sample_fetching', action: 'click' });
    }

    mailToManager () {
        this.$context.signal(raiseEvent, { category: 'link_letter_manager', action: 'click' });
    }
}

module.exports = {
    constructor: Order,
    children: [
        {
            name: 'custom-order',
            component: CustomOrder,
            props: {
                showReset: true,
                showOrderButton: true,
                onReset: signals.onReset,
                isSmallTree: 'false',
                dontUseMetric: 'false'
            },
            watcher: {
                hideRubrics: ['order', 'computed', 'hideRubrics']
            }
        },
        {
            name: 'slider',
            component: Slider,
            watcher: {
                cityPos: ['slider', 'positions', 'city'],
                buildingsPos: ['slider', 'positions', 'buildings'],
                cloudsPos: ['slider', 'positions', 'clouds'],
                noAnimation: ['slider', 'noAnimation'],
                page: ['slider', 'page']
            }
        },
        {
            name: 'discounts',
            component: Discounts,
            watcher: {
                prices: ['data', 'computed', 'discounts']
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/order/index.js